import { isNaturalClient } from '../clients'

const directorRelationships: ClientRelationship[] = ['DIRECTOR_TRUSTEE', 'DIRECTOR_TRUSTEE_AND_PSC', 'PSC']

export const getDirectors = (clients: ClientVersion[]) => {
  const nonNaturalClients = clients.filter((client) => !isNaturalClient(client.details)) as ClientVersion[]

  return nonNaturalClients.reduce((clientIds: string[], company) => {
    const relationships = company.details.relationships

    if (!relationships) return clientIds

    const directors = relationships
      .filter((relationship) => directorRelationships.includes(relationship.relationship_type as ClientRelationship))
      .map((director) => director.relationship_reference!)

    return [...clientIds, ...directors]
  }, [])
}
